import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as quickReportsActions from '../../actions/quickReportsActions';
import * as studyActions from '../../actions/studyActions';
import { EREADER_DISABLED_STUDY_LIST } from '../../actions/urlTypes';

class QuickReportsControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quickReportsStudy: props.quickReportsStudy,
      isViewScreenSelected: false,
      showBtn:
        props.quickReportsTarget &&
        props.quickReportsTarget.length > 0 &&
        props.selectedReport,
      selectedExportOption: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.quickReportsStudy !== nextProps.quickReportsStudy) {
      this.setState({
        quickReportsStudy: nextProps.quickReportsStudy,
        showBtn: false,
      });
    } else if (
      this.props.quickReportsTarget !== nextProps.quickReportsTarget ||
      this.props.selectedReport !== nextProps.selectedReport
    ) {
      this.setState({
        showBtn:
          nextProps.quickReportsTarget &&
          nextProps.quickReportsTarget.length > 0 &&
          nextProps.selectedReport,
      });
    }
  }

  getReportParams = ({ subType, combos, reportName = null, incrementalReach, weightList, mapSettings }) => ({
    token: this.props.loginResponse.data.token,
    uid: this.props.loginResponse.data.uid,
    accountId: this.props.activeAccountId,
    reportName: reportName || this.props.selectedReport.key,
    productNo: this.props.quickReportsStudy.pn,
    divisor: this.props.quickreportsWeightTypes.dv,
    weightType: weightList ? weightList.wt : this.props.quickreportsWeightTypes.wt,
    customWeights: weightList ? weightList.wt : this.props.quickreportsWeightTypes.wt,
    selectedWeight: weightList || this.props.quickreportsWeightTypes,
    targetLabel: this.props.quickReportsTarget[0].title,
    targetExpression: this.props.quickReportsTarget[0].keyword,
    baseLabel:
      this.props.quickReportsBase && this.props.quickReportsBase.length > 0
        ? this.props.quickReportsBase[0].title
        : undefined,
    baseExpression:
      this.props.quickReportsBase && this.props.quickReportsBase.length > 0
        ? this.props.quickReportsBase[0].keyword
        : undefined,
    subType,
    combos,
    incrementalReach,
    indexGroupCount: mapSettings && mapSettings.indexGroupCount,
    minIndex: mapSettings && mapSettings.minIndex,
    maxIndex: mapSettings && mapSettings.maxIndex,
  });

  logChange = val => {
    if (val.value === 'More') {
      this.studyModal.show();
    } else {
      this.props.studyActions.updateModuleStudy('quickReports', {
        ...val,
        wt: 1,
      });
    }
  };

  runReport = (subReportType, combos, reportName, incrementalReach, mapSettings) => {
    let subType = subReportType;
    if (
      reportName === 'MPAA' &&
      EREADER_DISABLED_STUDY_LIST.indexOf(this.props.quickReportsStudy.sti) !==
        -1
    ) {
      subType = 'game';
    }
    this.props.quickReportsActions.runQuickReports(
      this.getReportParams({ subType, combos, reportName, incrementalReach, mapSettings }),
    );
  };

  runReportFirstTime = wt => {
    this.props.quickReportsActions.setQuickReportRunFlag(false);
    let subType = this.props.selectedReport.subType;
    if (
      this.props.selectedReport.key === 'MPAA' &&
      EREADER_DISABLED_STUDY_LIST.indexOf(this.props.quickReportsStudy.sti) !==
        -1
    ) {
      subType = 'game';
    }
    const params = this.getReportParams({ subType,
      weightList: wt, mapSettings: this.props.mapSettings });
    this.props.quickReportsActions.runQuickReports(params);
  };

  render() {
    return (
      <div />
    );
  }
}

QuickReportsControls.propTypes = {
  selectedReport: PropTypes.shape({
    key: PropTypes.string,
    subType: PropTypes.string,
  }),
  quickReportsStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
    cw: PropTypes.number,
  }),
  quickReportsBase: PropTypes.arrayOf(PropTypes.object),
  quickReportsTarget: PropTypes.arrayOf(PropTypes.object),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  quickReportsActions: PropTypes.shape({
    runQuickReports: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  quickreportsWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
  }),
  mapSettings: PropTypes.instanceOf(Object),
  // trackerFn: PropTypes.func,
  // toggleQuickReportView: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    quickReportsStudy: state.study.quickReportsStudy,
    quickReportsBase: state.quickReports.BaseDataGridData,
    quickReportsTarget: state.quickReports.TargetDataGridData,
    selectedReport: state.quickReports.selectedReport,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
    mapSettings: state.quickReports.mapSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(QuickReportsControls);
